import Splide from '@splidejs/splide';

export default class ServicesSlider {

    getCarouselOptions(container) {

        new Splide(container, {
            type: 'loop',
            autoplay: false,
            interval: 3000,
            lazyLoad: true,
            easing: 'ease',
            drag: true,
            pagination: true,
            adaptiveHeight: true,
            arrows: false,
            perPage: 1,
            perMove: 1,
            mediaQuery: 'min',

            breakpoints: {
                576: {
                    perPage: 2,
                    gap: '.5em',
                },
                768: {
                    perPage: 3,
                },
                992: {
                    perPage: 4,
                },
                1200: {
                    pagination: false,
                    arrows: true,
                },
            },

        }).mount();

    }

    triggerCarousel() {
        const blocks = document.querySelectorAll(".services-slider__wrapper");
        if (blocks.length) {
            [...blocks].forEach((block) => {
                    const slider = block.querySelector(".services-splide");

                    if (slider) {
                        this.getCarouselOptions('.services-splide');
                    }

                }
            );
        }
    }

    init() {
        this.triggerCarousel()
    }
}
